import * as types from './types';
import { NoteResource } from 'util/resources/Note';

const initialState = {
  loading: false,
  notes: [],
};

const notesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.NOTES_LOAD_START:
      return { ...state, loading: true };
    case types.NOTES_LOAD_SUCCESS:
      const notes = payload as NoteResource[];
      return { ...state, loading: false, notes };
    case types.NOTES_LOAD_FAILURE:
      return { ...state, loading: false };
    case types.NOTES_CREATE_START:
      return { ...state, loading: true };
    case types.NOTES_CREATE_SUCCESS:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default notesReducer;
